var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSyndicateProducts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1339_137031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5H18C19.11 5 20 5.89 20 7H18H15H13H11H7V9H5V7H2V16V18H11V20H2C0.89 20 0 19.11 0 18V7C0 5.89 0.89 5 2 5H5V3C5 1.89 5.89 1 7 1H13C14.11 1 15 1.89 15 3V5ZM13 3H7V5H13V3Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2601 13.2618L12.0003 15.235L13.9735 17.4948C15.2239 16.403 15.3519 14.5122 14.2601 13.2618ZM17.2731 10.6309L15.7666 11.9464C17.5819 14.0254 17.368 17.186 15.289 19.0013L16.6044 20.5078C19.5195 17.9624 19.8185 13.546 17.2731 10.6309ZM20.2861 8L18.7796 9.31546C22.0485 13.0591 21.6636 18.7454 17.9199 22.0143L19.2354 23.5208C23.8151 19.5218 24.2785 12.5723 20.2861 8Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1339_137031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyndicateProducts);
export default __webpack_public_path__ + "static/media/syndicate-products.5ca41fb5.svg";
export { ForwardRef as ReactComponent };